import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import '../App.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // If opened in new tab, close the window; otherwise navigate back
    if (window.history.length <= 2) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <img src="/epg_logo.png" alt="EPG Logo" className="logo-icon" />
          </div>
          <div className="header-buttons">
            <Button variant="outline" className="header-btn" onClick={handleBack}>
              Back
            </Button>
          </div>
        </div>
      </header>

      {/* Privacy Policy Content */}
      <section className="contact-section" style={{ paddingTop: '120px', paddingBottom: '80px' }}>
        <div className="contact-container" style={{ maxWidth: '800px' }}>
          <h1 className="contact-title" style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>
            Privacy Policy
          </h1>
          <div style={{ 
            color: 'rgba(255, 255, 255, 0.9)', 
            lineHeight: '1.8',
            fontSize: '1.1rem',
            textAlign: 'left'
          }}>
            <p style={{ marginBottom: '1.5rem' }}>
              Electrum Prosperity Group ("EPG") respects your privacy and is committed to protecting your personal information. When you visit our website, sign up, or interact with our services, we may collect basic information such as your name, email address, or contact details solely to communicate with you, provide resources, and improve our services.
            </p>
            <p style={{ marginBottom: '1.5rem' }}>
              By using our website and services, you consent to this privacy policy. If you have any questions or concerns about how your information is handled, please contact us directly.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
